module.exports = __webpack_public_path__ + "img/hawke-riya.0a91118f.png";